<template>
    <div>
        <rkm-form ref="Form">
            <rkm-tabs v-model="tabIndex">

                <rkm-tab
                    title="AGENDAR EXAMES RETROATIVOS"
                    @click.prevent="setActive('InclusaoAgendamento')"
                >
                    <tab-agendar-exames
                        ref="TabAgendarExames"
                        :data="{form, model}"
                        :feriado="form.feriados"
                        :agendamento="agendamento"
                        :diasCalendario="diasCalendario"
                        :index="index"
                        :vagas="vagas"
                        :jornadas="jornadas"
                        :vagasPreenchidas="vagasPreenchidas"
                        :horaSave="horaSave"
                        :unidadeExecutante="unidadeExecutante"
                        :grupo="grupo"
                        :profissional="profissional"
                        @setFields="setFields"
                        @loadInfraestrutura="loadInfraestrutura"
                        @loadDiasCalendario="loadDiasCalendario"
                        @resetProfissional="resetProfissional"
                        @resetGrupoExame="resetGrupoExame"
                        @loadVagas="loadVagas"
                        @alterCalendar="alterCalendar"
                    />
                </rkm-tab>

                <rkm-tab
                    title="EXAMES AGENDADOS"
                    @click.prevent="setActive('agendamentosCadastradas')"
                >
                    <tab-exames-agendados
                        ref="TabExamesAgendados"
                        :data="{form, model}"
                        @handleAlter="handleAlter"
                        @loadDays="loadDays"
                    />
                </rkm-tab>

                <rkm-tab
                    title="EXAMES CANCELADOS"
                    @click.prevent="setActive('agendamentosCancelados')"
                >
                    <tab-exames-cancelados
                        ref="TabExamesCancelados"
                        :data="{form, model}"
                    />
                </rkm-tab>

                <rkm-tab
                    title="EXAMES EXCLUÍDOS"
                    @click.prevent="setActive('agendamentosExcluidos')"
                >
                    <tab-exames-excluidos
                        ref="TabExamesExcluidos"
                        :data="{form, model}"
                    />
                </rkm-tab>
            </rkm-tabs>
        </rkm-form>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

//Moment
import moment from 'moment'

// Enuns.
import modulo from '@/enums/cadastro/feriado/modulo'
import tipoControleJornada from '@/enums/exame-imagem/tipoControleJornada'
import status from '@/enums/exame-imagem/fechamento/status'

// Mixins.
import { formats, repository, stringCase, object, error, data, printExameImagem } from '@/mixins'

// Components.
import TabExamesAgendados from '@/components/exame-imagem/agendamento-retroativo/tabs/agendados/Index'
import TabAgendarExames from '@/components/exame-imagem/agendamento-retroativo/tabs/cadastro/Form'
import TabExamesExcluidos from '@/components/exame-imagem/agendamento-retroativo/tabs/excluidos/Index'
import TabExamesCancelados from '@/components/exame-imagem/agendamento-retroativo/tabs/cancelados/Index'

export default {
    components: {
        TabExamesAgendados,
        TabAgendarExames,
        TabExamesExcluidos,
        TabExamesCancelados,
    },
    computed: {
        unidadeExecutante(){

            return this.form.unidadeExecutante ? this.form.unidadeExecutante : []
        },
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('exameImagem.agendamentoRetroativo'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        },
        this.load()
    },
    data: () => ({
        additionals: null,
        form: {},
        model: {
            cadastro: [],
            inclusao: [],
            medicoSolicitante: null,
            pacienteId: null,
        },
        feriado: {},
        tabIndex: 0,
        index: null,
        paciente: {
            cidadao:[]
        },
        vagas: [],
        jornadas: [],
        vagasPreenchidas: 0,
        horaSave: null,
        agendamento: {
            alterar: false,
            agendamentoNumero: '',
            retroativo: true,
            impressao: true,
            data: null,
            dataTradada: null,
            dataMenstruacao: null,
            horaInicial: null,
            grupoExameId: null,
            grupoExameNome: '',
            exames: [],
            gestante: false,
            horaExame: '',
            jornadaId: null,
            controleJornadaId: null,
            infraestruturaId: null,
            infraestruturaNome: '',
            agendamentoId: null,
            unidadeId: null,
            unidadeNome: '',
            profissionalNome: '',
            profissionalId: null,
            prestadorId: null,
            unidadeDisabled: false,
            usuarioId: '',
            unidadeSolicitanteId: null,
            infraestruturaSolicitanteId: null,
            observacao: '',
            usuarioNome: '',
            selecionado: false,
            urgente: false,
            pacienteId: '',
            sexoId: '',
            medicoSolicitante: null,
            medicoNome: '',
            medicoId: null,
            nomeResponsavel: '',
            incluido: [],
            supervisorId: null,
            cotasPrestadores: [],
            agendadorId: null,
        },
        enums: {
            modulo,
            tipoControleJornada,
            status
        },
        diasCalendario: [],
        dataInformada: '',
        grupo: [],
        profissional: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.agendamento.show(this.id)
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.loadPaciente(data.form.paciente)

                    this.paciente.cidadao.idade = data.form.paciente.cidadao.idade.anos

                    if (data.form.paciente.cidadao.idade.anos < 18 || data.form.paciente.cidadao.idade.anos >= 60) {

                        this.agendamento.nomeResponsavel = data.form.paciente.cidadao.nomeMae
                    }

                    this.agendamento.unidadeSolicitanteId  = data.form.unidadeLogada
                    this.agendamento.infraestruturaSolicitanteId  = data.form.localAtendimentoLogado

                    this.$nextTick().then(() => {

                        this.tabRefs = [
                            this.$refs.TabExamesAgendados,
                            this.$refs.TabAgendarExames,
                        ]
                    })

                    this.$emit('loaded', {additionals: this.additionals, form: this.form})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setFields(field) {

            if (field == 'unidadeExecutante') {

                this.agendamento.infraestruturaId = null
                this.agendamento.grupoExameId = null
                this.agendamento.profissionalId = null

                let infraestruturaPrincipal = this.form.unidadeExecutante.find(u =>
                    u.unidadeId === this.agendamento.unidadeId)

                if(infraestruturaPrincipal){

                    this.loadInfraestrutura(infraestruturaPrincipal.infraestruturas)
                }

                if (this.agendamento.infraestruturaId) {

                    this.loadGrupo()
                }
            } else if (field == 'infraestruturaId') {

                this.agendamento.grupoExameId = null
                this.agendamento.profissionalId = null

                if (this.agendamento.infraestruturaId) {

                    this.loadGrupo()
                }

            } else if (field == 'grupoExameId') {

                this.agendamento.profissionalId = null

                if (this.agendamento.grupoExameId) {

                    this.loadProfissional()
                }

            } else if (field == 'profissionalId' || this.agendamento.profissionalId){

                this.loadVagas()
            }

            if (field !== 'unidadeExecutante' && field !== 'infraestruturaId') {

                this.loadDays()
            }
        },
        loadInfraestrutura(infraestrutura) {

            const infraestruturaPrincipal = infraestrutura.find(u => u.principal)

            if (infraestruturaPrincipal) {
                this.agendamento.infraestruturaId = infraestruturaPrincipal.infraestruturaId;
            }
        },
        loadGrupo(){

            this.setLoading()

                this.repositories.agendamento.getGrupo({
                    unidade_id: this.agendamento.unidadeId,
                    infraestrutura_id: this.agendamento.infraestruturaId,
                })
               .then(({ data }) => {

                    this.grupo = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadProfissional(){

            this.setLoading()

                this.repositories.agendamento.getProfissional({
                    unidade_id: this.agendamento.unidadeId,
                    infraestrutura_id: this.agendamento.infraestruturaId,
                    exame_id: this.agendamento.grupoExameId,
                })
               .then(({ data }) => {

                    this.profissional = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setMedico(){
            this.medico = {
                medico: null
            }
        },
        setAgendamento(){
            this.agendamento = {
                alterar: false,
                retroativo: true,
                agendamentoId: null,
                agendamentoNumero: '',
                data: null,
                dataTradada: null,
                dataMenstruacao: null,
                grupoExameId: null,
                grupoExameNome: '',
                exames: [],
                gestante: false,
                impressao: true,
                horaInicial: null,
                horaExame: '',
                infraestruturaId: null,
                infraestruturaNome: '',
                jornadaId: null,
                controleJornadaId: null,
                unidadeId: null,
                unidadeSolicitanteId: null,
                unidadeLogadaNome:'',
                infraestruturaSolicitanteId: null,
                infraestruturaSolicitanteNome: '',
                unidadeNome: '',
                profissionalNome: '',
                profissionalId: null,
                prestadorId: null,
                unidadeDisabled: false,
                usuarioId: '',
                usuarioNome: '',
                selecionado: false,
                statusId: null,
                urgente: false,
                pacienteId: '',
                observacao: '',
                sexoId: '',
                medicoSolicitante: null,
                medicoNome: '',
                medicoId: null,
                nomeResponsavel: '',
                incluido:[],
                supervisorId: null,
                agendadorId: null,
            }

            this.agendamento.nomeResponsavel = this.form.paciente.cidadao.nomeMae
            this.agendamento.unidadeSolicitanteId  = this.form.unidadeLogada
            this.agendamento.infraestruturaSolicitanteId  = this.form.localAtendimentoLogado

            this.vagas = [],
            this.horaSave = null,
            this.loadDays()
        },
        continueAgendamento() {

            this.agendamento.alterar = false
            this.agendamento.retroativo = true
            this.agendamento.agendamentoId = null
            this.agendamento.agendamentoNumero = ''
            this.agendamento.data = null
            this.agendamento.dataTradada = null
            this.agendamento.dataMenstruacao = null
            this.agendamento.grupoExameId = null
            this.agendamento.grupoExameNome = ''
            this.agendamento.exames = []
            this.agendamento.impressao = true
            this.agendamento.horaInicial = null
            this.agendamento.horaExame = ''
            this.agendamento.jornadaId = null
            this.agendamento.controleJornadaId = null
            this.agendamento.selecionado = false
            this.agendamento.statusId = null
            this.agendamento.urgente = false
            this.agendamento.observacao = ''
            this.agendamento.nomeResponsavel = ''
            this.agendamento.incluido = []
            this.agendamento.supervisorId = null
            this.agendamento.agendadorId = null
            this.agendamento.prestadorId = null,
            this.agendamento.profissionalId = null,

            this.index = null
            this.vagas = []
            this.horaSave = null

            this.load()
            this.$refs.TabAgendarExames.resetValidate()
        },
        setActive(){

            this.setAgendamento()
            this.setMedico()
            this.index = null
        },
        loadPaciente(paciente) {

            if(!paciente.unidade){

                const confirm = async () => {

                    this.$emit('handleAtualizaPaciente')
                }

                const cancel = async () => {

                    this.$emit('handleExitPaciente')
                }

                const msg = 'Algumas informações do(a) paciente estão com erro ou desatualizadas. ' +
                    'Para realizar o agendamento é necessário atualiza-lo. Deseja atualizar?'

                    this.showConfirmation(msg, confirm, cancel)

                return false

            } else {

                this.paciente.id = paciente.id
                this.paciente.nome = paciente.cidadao.nome
                this.paciente.preferenciaNomeId = paciente.cidadao.preferenciaNomeId
                this.paciente.nomeSocial = paciente.cidadao.nomeSocial
                this.paciente.prontuario = paciente.prontuario
                this.paciente.cpf = paciente.cidadao.cpf
                this.paciente.cns = paciente.cidadao.cns
                this.paciente.telefone = paciente.cidadao.telefonePrincipal.numero
                this.paciente.dataNascimento = paciente.cidadao.dataNascimento
                this.paciente.idade = paciente.cidadao.idade
                this.paciente.anos = paciente.cidadao.idade.anos
                this.paciente.meses = paciente.cidadao.idade.meses
                this.paciente.dias = paciente.cidadao.idade.dias
                this.paciente.sexo = paciente.cidadao.sexo
                this.paciente.sexoId = paciente.cidadao.sexo.id
                this.paciente.sexoDescricao = paciente.cidadao.sexo.descricao
                this.paciente.nomeMae = paciente.cidadao.nomeMae
                this.paciente.unidadeReferencia = paciente.unidade.nomeFantasia

                if (!paciente.cidadao.cpf || !paciente.cidadao.cns || !paciente.cidadao.telefonePrincipal.numero ||
                    !paciente.cidadao.dataNascimento || !paciente.cidadao.sexo.id ||
                    (!paciente.cidadao.desconheceNomeMae && !paciente.cidadao.nomeMae)) {

                    const confirm = async () => {

                        this.$emit('handleAtualizaPaciente')
                    }

                    const cancel = async () => {

                        this.$emit('handleExitPaciente')
                    }

                    const msg = 'O cadastro do paciente está incompleto. Para realizar o agendamento é necessário' +
                        ' atualiza-lo. Deseja atualizar?'

                        this.showConfirmation(msg, confirm, cancel)

                    return false
                }
            }
        },
        save(){

            if(this.tabIndex == 0){

                this.$refs.Form.validate()
                    .then(valid => {

                        if (!valid) return
                        if (!this.validateFields()) return

                        this.setLoading()

                        this.repositories.agendamento.store(this.prepareData())
                            .then(({ data }) => {

                                this.showSaveNotification()

                                this.handlePrint(data.impressaoAgendamentoNumero)

                                this.showConfirmation("Deseja agendar um novo exame para o mesmo paciente?",
                                    async () => this.continueAgendamento(),
                                    async () => this.$emit('save', data)
                                )
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    })
            } else {

                this.setLoading()

                this.repositories.agendamento.store(this.prepareData())
                    .then(({ data }) => {

                        this.showSaveNotification()

                        this.showConfirmation("Deseja agendar um novo exame para o mesmo paciente?",
                            async () => this.continueAgendamento(),
                            async () => this.$emit('save', data)
                        )
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handlePrint(agendamentoNumero) {

            var executantePrincipal = this.form.unidadeExecutante.find(u => u.unidadeId === this.agendamento.unidadeId)

            var  infraestruturaPrincipal = executantePrincipal.infraestruturas.find(f => f.infraestruturaId === this.agendamento.infraestruturaId)

            let agendamento = {
                pacienteNome: this.form.paciente.cidadao.nome,
                prontuario: this.form.paciente.prontuario,
                nomeResponsavel: this.agendamento.responsavel,
                dataNascimento: this.form.paciente.cidadao.dataNascimento.split("-").reverse().join("/"),
                agendamentoNumero: agendamentoNumero,
                medicoNome: this.agendamento.medicoSolicitante.cidadaoNome,
                observacao: this.agendamento.observacao,
                profissionalNome: this.agendamento.profissionalNome,
                grupoExameNome: this.agendamento.exameNome,
                unidadeSolicitante: this.form.unidadeLogadaNome,
                data: moment(this.agendamento.data).format('DD/MM/YYYY'),
                examesIncluido: this.agendamento.incluido,
                horaExame: this.agendamento.horaExame,
                logotipo: this.form.cliente.logotipo,
                nomePrefeitura: this.form.cliente.nome,
                ramoAtividade: this.form.cliente.sistema.ramoAtividade.nome,
                mensagemProtocolo: this.form.mensagemProtocolo,
                sistemaNome: this.form.cliente.sistema.nome,
                sistemaVersao: this.form.cliente.sistema.versao,
                usuario: this.form.usuario,
                usuarioNomeSocial: this.form.usuarioNomeSocial ? this.form.usuarioNomeSocial : null,
                urgente: this.agendamento.urgente,
                unidadeExecutante: this.agendamento.unidadeNome,
                enderecoExecutante: infraestruturaPrincipal.endereco,
                numeroEnderecoExecutante: infraestruturaPrincipal.numeroEndereco,
                bairroExecutante: infraestruturaPrincipal.bairro,
                telefoneExecutante: infraestruturaPrincipal.telefone,
            }

            this.print().agendamento(agendamento)
        },
        prepareData() {

            const agendamentoNovo = this.clone(this.agendamento)

            if(agendamentoNovo.jornadaId !== null){

                agendamentoNovo.unidadeSolicitanteId = this.form.unidadeLogada
                agendamentoNovo.infraestruturaSolicitanteId = this.form.localAtendimentoLogado

                agendamentoNovo.medicoId = agendamentoNovo.medicoSolicitante.id
                agendamentoNovo.medicoNome = agendamentoNovo.medicoSolicitante.nome

                agendamentoNovo.dataMenstruacao = this.getFormatedDate(agendamentoNovo.dataMenstruacao, 'DD/MM/YYYY')
                agendamentoNovo.agendamentoNumero = new Date().getTime()

                if (agendamentoNovo.agendamentoId == null) {

                    agendamentoNovo.agendamentoId = this.uniqueId('agendamento' + new Date().getTime())

                    this.model.agendamentos.push(agendamentoNovo)

                } else {

                    const objIndex = this.model.agendamentos.findIndex((obj =>
                        obj.agendamentoId == agendamentoNovo.agendamentoId
                    ));

                    this.$set(this.model.agendamentos, objIndex, this.clone(agendamentoNovo))
                }
            }

            this.model.pacienteId = this.form.paciente.id

            return this.camelObjectKeysToSnakeRecursive(this.model)
        },
        handleAlter(item, index ) {

            this.model.agendamentos.filter(obj => obj.agendamentoId == item.agendamentoId)
                .forEach(exameIncluido => {

                    if(exameIncluido.incluido.find(m => m.statusId == this.enums.status.REALIZADO
                        || m.statusId == this.enums.status.FALTOU || m.faturamento)){

                        this.showValidationNotification(`Não é possível realizar a alteração desse agendamento,
                            pois há um ou mais exames realizados, faturados ou com ausência do paciente registrada.`)

                    } else {

                        this.agendamento = item
                        this.index = index

                        this.agendamento.alterar = true

                        this.agendamento.impressao = true

                        this.tabIndex = 0

                        this.horaSave = item.horaExame

                        this.loadVagas()
                    }
                })
        },
        loadVagas() {

            this.vagas = []
            this.jornadas = []

            this.setLoading()

            this.repositories.agendamento.getJornadas({
                unidade_id: this.agendamento.unidadeId,
                infraestrutura_id: this.agendamento.infraestruturaId,
                exame_id: this.agendamento.grupoExameId,
                profissional_id: this.agendamento.profissionalId,
            })
            .then(response => {
                this.vagas = response.data.agendamentos
                this.jornadas = response.data.jornadas
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading(this.$nextTick(() => this.alterCalendar(this.agendamento.data))))
        },
        alterCalendar(data){

            let diasCalendario = []

            let dataAtual = this.form.dataAtual

            dataAtual = dataAtual.split("/").reverse().join("-")

            if (this.jornadas.length == 0) {

                this.showValidationNotification(`Não existe jornada cadastrada para esse profissional.`)
                return false
            }

            this.jornadas.filter(u => u.profissionalId === this.agendamento.profissionalId
                && u.exameId === this.agendamento.grupoExameId && u.unidadeId === this.agendamento.unidadeId)
                .map(unidade => {

                    const feriado = this.form.feriados.find(feriado => feriado.data === unidade.data);
                    const isFeriado = !!feriado;

                    if (isFeriado) {
                        diasCalendario.push({
                            'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                            'highlight': 'yellow',
                            'title': feriado.tipoNome,
                            'popover': feriado.observacao,
                            'clickable': false
                        });
                    }

                    if (moment(unidade.data.split("/").reverse().join("-")).isBefore(dataAtual)) {

                            if (data && data == unidade.data.split("/").reverse().join("-")) {

                            let vagas = this.loadQuantidadeVagas(unidade)

                                diasCalendario.push({
                                    'dates': data.split("-").reverse().join("/"),
                                    'title': `${this.getJornada(unidade) + 1}/${vagas}`,
                                    'highlight': 'blue',
                                })

                            } else {

                                let vagas = this.loadQuantidadeVagas(unidade)

                                if(this.getJornada(unidade) >= vagas){

                                    diasCalendario.push({
                                        'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                                        'title': `${this.getJornada(unidade)}/${vagas}`,
                                        'highlight': 'red',
                                    })

                                } else {

                                    let vagas = this.loadQuantidadeVagas(unidade)

                                    diasCalendario.push({
                                        'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                                        'title': `${this.getJornada(unidade)}/${vagas}`,
                                        'highlight': 'green',
                                    })
                                }
                            }
                    } else {

                        if (data && data == unidade.data.split("/").reverse().join("-")) {

                            let vagas = this.loadQuantidadeVagas(unidade)

                            diasCalendario.push({
                                'dates': data.split("-").reverse().join("/"),
                                'title': `${this.getJornada(unidade) + 1}/${vagas}`,
                                'highlight': 'blue',
                            })
                        }
                    }
            })

            this.form.feriados.map(feriado => {

                diasCalendario.push({
                    'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                    'highlight': 'yellow',
                    'title': feriado.tipoNome,
                    'popover':  feriado.observacao
                })
            })

            this.diasCalendario = diasCalendario
        },
        getJornada(agendamento) {

            let vagasPreenchidas = 0

            if(agendamento.controleJornadaId == this.enums.tipoControleJornada.EXAME){

                this.vagas.filter(item => item.data === agendamento.data)
                    .map(exameIncluido => {

                        vagasPreenchidas = vagasPreenchidas + exameIncluido.incluido.length
                    })

                    return vagasPreenchidas

            } else {

                vagasPreenchidas = this.vagas.filter(item => item.data === agendamento.data).length;

                return vagasPreenchidas
            }
        },
        loadQuantidadeVagas(unidade) {

            let quantidade = this.jornadas.filter(item => item.data === unidade.data
                && item.profissionalId === this.agendamento.profissionalId
                && item.exameId === this.agendamento.grupoExameId
                && item.unidadeId === this.agendamento.unidadeId
            )
                .reduce((sum, element) => {

                    if (element.vagas) {
                        sum = sum + Number(element.vagas) + Number(element.vagasApp || 0);
                    }

                    return sum;
                },0)

            return quantidade
        },
        resetProfissional(){

            this.agendamento.profissionalId = null
            this.loadDays()
        },
        resetGrupoExame(){

            this.agendamento.grupoExameId = null
            this.loadDays()
        },
        validateFields() {

            if (this.agendamento.data === null) {

                this.showValidationNotification('Obrigatório selecionar uma data.')
                return false
            }

            if (this.agendamento.horaExame === null) {

                this.showValidationNotification('Obrigatório selecionar um horário.')
                return false
            }

            if (this.agendamento.incluido.length == 0) {

                this.showValidationNotification('Obrigatório atribuir pelo menos um exame no agendamento.')
                return false
            }

            return true
        },
        validate() {
            return this.tabRefs[this.tabIndex].validate()
        },
        loadDays() {

            let diasCalendario = []

            this.form.feriados.map(feriado =>

                diasCalendario.push({
                    'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                    'highlight': 'yellow',
                    'title': feriado.tipoNome,
                    'popover':  feriado.observacao
                })

            )

            this.loadDiasCalendario(diasCalendario)
        },
        loadDiasCalendario(value) {

            this.diasCalendario = value
        },
    },
    mixins: [formats, repository, stringCase, object, error, data, printExameImagem],
    props: {
        id: { type: Number },
    },
}
</script>

<style>
.tabs {
    border: 0px solid #dee2e6!important;
    border-radius: 0.25rem;
}
</style>